import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[ksTabPanel]',
})
export class TabPanelDirective {
  readonly value = input.required<string>();
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}

@Directive({
  selector: 'ng-template[ksStepTabEditDescriptionDef]',
})
export class StepTabEditDescriptionDefDirective {
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
